import { POST } from "../../index";
export const queryUserList = (param) => POST("/v1/user/queryUserList", param);
export const addUser = (param) => POST("/v1/user/addUser", param);
export const deleteUser = (param) => POST("/v1/user/deleteUser", param);
export const resetPassword = (param) => POST("/v1/user/resetPassword", param);
export const updateUser = (param) => POST("/v1/user/updateUser", param);
export const updateUserLoginPwd = (param) => POST("/v1/user/updateUserLoginPwd", param);
